import { c as _c } from "react/compiler-runtime";
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
export const Settings = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SettingsIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};